exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reservation__notes--red-dot[data-v-4d92aa62] {\n  background-color: #f16c64;\n  width: 6px;\n  height: 6px;\n  display: inline-block;\n  border-radius: 50%;\n  margin-bottom: 4px;\n  margin-right: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4d92aa62","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEditV2/TabCustomer/Notes.vue
// module id = 1874
// module chunks = 0